import { Component } from "@angular/core";

import { OnInit } from "@angular/core";

import { MatDialog } from "@angular/material";
import { ManageTruckDialogComponent } from './manage-truck/manage-truck.component';
import { MiscService } from '../../services/misc.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';

@Component({
  selector: "rm-manage-asset",
  templateUrl: "./manage-asset.component.html",
  styleUrls: ["./manage-asset.component.css"]
})
export class ManageAssetComponent implements OnInit {
  gcp: any;
  stats: any;

  constructor(
    private dialog: MatDialog,
    private miscService: MiscService,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService
  ) { }

  ngOnInit() {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }

    this.loadStats();

    this.ebService.assetFetchedValue$.subscribe(
      ()=> {
        this.loadStats();
      }
    );
  }

  loadStats() {

    this.miscService.getAssetsStat(this.gcp).subscribe(
      (result)=> {
        this.stats = result;
      }
    );
  }

  manageTruck(type?) {
    const dialogRef = this.dialog.open(ManageTruckDialogComponent, {
      width: "1200px",
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
    });
  }
}
